function normalizeLang(v) {
  return v === "ru" || v === "en" ? v : null;
}
const ru = {
  // — COMMON (кнопки/действия, встречаются почти везде) —
  "common.open": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C",
  "common.close": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
  "common.back": "\u041D\u0430\u0437\u0430\u0434",
  "common.save": "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
  "common.cancel": "\u041E\u0442\u043C\u0435\u043D\u0430",
  "common.confirm": "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
  "common.yes": "\u0414\u0430",
  "common.no": "\u041D\u0435\u0442",
  "common.language": "\u042F\u0437\u044B\u043A",
  "common.loading": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
  // — MENU (разделы главного меню / F1) —
  "menu.stats": "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430",
  "menu.battlepass": "\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u0440\u043E\u043F\u0443\u0441\u043A",
  "menu.character": "\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u0436",
  "menu.business": "\u0411\u0438\u0437\u043D\u0435\u0441",
  "menu.organization": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
  "menu.achievements": "\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F",
  "menu.settings": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
  // — MENU: общая оболочка / подзаголовки —
  "menu.kicker": "\u041C\u0435\u043D\u044E \u0438\u0433\u0440\u043E\u043A\u0430",
  "menu.close": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \xB7 F1",
  "menu.empty": "\u041F\u043E\u043A\u0430 \u043D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445",
  // — STATS (раздел статистики) —
  "stats.kicker": "\u041F\u0440\u043E\u0444\u0438\u043B\u044C",
  "stats.title": "\u041E\u0431\u0437\u043E\u0440 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u0436\u0430",
  "stats.level": "\u0423\u0440\u043E\u0432\u0435\u043D\u044C",
  "stats.hours": "\u0427\u0430\u0441\u043E\u0432 \u0432 \u0438\u0433\u0440\u0435",
  "stats.cash": "\u041D\u0430\u043B\u0438\u0447\u043D\u044B\u0435",
  "stats.bank": "\u0411\u0430\u043D\u043A",
  "stats.reputation": "\u0420\u0435\u043F\u0443\u0442\u0430\u0446\u0438\u044F",
  "stats.deeds": "\u043F\u043E\u0441\u0442\u0443\u043F\u043A\u043E\u0432",
  "stats.job": "\u0420\u0430\u0431\u043E\u0442\u0430",
  "stats.job.none": "\u0411\u0435\u0437 \u0440\u0430\u0431\u043E\u0442\u044B",
  "stats.rank": "\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C",
  "stats.home": "\u0416\u0438\u043B\u044C\u0451",
  "stats.home.none": "\u0411\u0435\u0437 \u0436\u0438\u043B\u044C\u044F",
  "stats.lastPlace": "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u043C\u0435\u0441\u0442\u043E",
  "stats.hoursUnit": "\u0447",
  // — BATTLE PASS (раздел боевого пропуска) —
  "bp.kicker": "\u0421\u0435\u0437\u043E\u043D",
  "bp.title": "\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u0440\u043E\u043F\u0443\u0441\u043A",
  "bp.level": "\u0423\u0440\u043E\u0432\u0435\u043D\u044C {n}",
  "bp.daysLeft": "{n} \u0434\u043D \u0434\u043E \u043A\u043E\u043D\u0446\u0430",
  "bp.premium.active": "\u041F\u0440\u0435\u043C\u0438\u0443\u043C \u0430\u043A\u0442\u0438\u0432\u0435\u043D",
  "bp.premium.buy": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u0435\u043C\u0438\u0443\u043C \xB7 {jc} JC",
  "bp.track": "\u0414\u043E\u0440\u043E\u0436\u043A\u0430 \u043D\u0430\u0433\u0440\u0430\u0434",
  "bp.free": "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E",
  "bp.prem": "\u041F\u0440\u0435\u043C\u0438\u0443\u043C",
  "bp.claim": "\u0417\u0430\u0431\u0440\u0430\u0442\u044C",
  "bp.claimed": "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E",
  "bp.locked": "\u0417\u0430\u043A\u0440\u044B\u0442\u043E",
  "bp.reach": "\u0423\u0440. {n}",
  "bp.fair": "\u041D\u0430\u0433\u0440\u0430\u0434\u044B \u2014 \u043A\u043E\u0441\u043C\u0435\u0442\u0438\u043A\u0430, \u0441\u0442\u0430\u0442\u0443\u0441 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430. \u041D\u0438 \u0443\u0440\u043E\u043D\u0430, \u043D\u0438 \u0431\u0440\u043E\u043D\u0438, \u043D\u0438 \u0434\u0435\u043D\u0435\u0433.",
  "bp.openApp": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u043F\u0440\u043E\u043F\u0443\u0441\u043A",
  // — CHARACTER (раздел персонажа) —
  "char.kicker": "\u0420\u0430\u0437\u0432\u0438\u0442\u0438\u0435",
  "char.title": "\u041B\u0438\u0441\u0442 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u0436\u0430",
  "char.cl": "\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u0436\u0430",
  "char.skills": "\u041D\u0430\u0432\u044B\u043A\u0438",
  "char.rep": "\u0420\u0435\u043F\u0443\u0442\u0430\u0446\u0438\u044F",
  "char.ranks": "\u0420\u0430\u043D\u0433\u0438",
  "char.rep.none": "\u041F\u043E\u043A\u0430 \u0431\u0435\u0437 \u0440\u0435\u043F\u0443\u0442\u0430\u0446\u0438\u0438 \u0432 \u043A\u0440\u0443\u0433\u0430\u0445",
  "char.ranks.none": "\u0411\u0435\u0437 \u0440\u0430\u0431\u043E\u0442\u044B \u0438 \u0444\u0440\u0430\u043A\u0446\u0438\u0438",
  "char.openSheet": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043B\u0438\u0441\u0442 (P)",
  // — BUSINESS (раздел бизнеса) —
  "biz.kicker": "\u0418\u043C\u043F\u0435\u0440\u0438\u044F",
  "biz.title": "\u041C\u043E\u0438 \u0431\u0438\u0437\u043D\u0435\u0441\u044B",
  "biz.none": "\u0423 \u0432\u0430\u0441 \u043F\u043E\u043A\u0430 \u043D\u0435\u0442 \u0431\u0438\u0437\u043D\u0435\u0441\u043E\u0432",
  "biz.treasury": "\u041A\u0430\u0437\u043D\u0430",
  "biz.share": "\u0414\u043E\u043B\u044F",
  "biz.role.owner": "\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446",
  "biz.role.partner": "\u041F\u0430\u0440\u0442\u043D\u0451\u0440",
  "biz.manager": "\u041C\u0435\u043D\u0435\u0434\u0436\u0435\u0440",
  "biz.manager.none": "\u0411\u0435\u0437 \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u0430",
  // — ORGANIZATION (раздел организации/фракции) —
  "org.kicker": "\u0424\u0440\u0430\u043A\u0446\u0438\u044F",
  "org.title": "\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F",
  "org.none": "\u0412\u044B \u043D\u0435 \u0441\u043E\u0441\u0442\u043E\u0438\u0442\u0435 \u0432\u043E \u0444\u0440\u0430\u043A\u0446\u0438\u0438",
  "org.rank": "\u0420\u0430\u043D\u0433",
  "org.members": "\u0421\u043E\u0441\u0442\u0430\u0432 (\u043E\u043D\u043B\u0430\u0439\u043D)",
  "org.turf": "\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0439",
  "org.turf.none": "\u041D\u0435\u0442 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u0443\u0435\u043C\u044B\u0445 \u0442\u043E\u0447\u0435\u043A",
  "org.control": "\u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C",
  // — ACHIEVEMENTS (раздел достижений) —
  "ach.kicker": "\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441",
  "ach.title": "\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F",
  "ach.streak": "\u0421\u0435\u0440\u0438\u044F \u0432\u0445\u043E\u0434\u043E\u0432",
  "ach.days": "\u0434\u043D\u0435\u0439",
  "ach.daysActive": "\u0410\u043A\u0442\u0438\u0432\u043D\u044B\u0445 \u0434\u043D\u0435\u0439",
  "ach.next": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0432\u0435\u0445\u0430",
  "ach.milestones": "\u0412\u0435\u0445\u0438",
  "ach.claimed": "\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E",
  "ach.locked": "\u0414\u0435\u043D\u044C {n}",
  "ach.none": "\u0412\u0435\u0445\u0438 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u043F\u043E \u043C\u0435\u0440\u0435 \u0438\u0433\u0440\u044B",
  // — SETTINGS (экран настроек) —
  "settings.title": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
  "settings.kicker": "\u0418\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441",
  "settings.language": "\u042F\u0437\u044B\u043A",
  "settings.language.ru": "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
  "settings.language.en": "English",
  "settings.applied": "\u042F\u0437\u044B\u043A \u0438\u0437\u043C\u0435\u043D\u0451\u043D",
  "settings.hud": "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 HUD",
  "settings.hud.note": "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u044C \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u2014 F7 \u0432 \u0438\u0433\u0440\u0435",
  "settings.volume": "\u0413\u0440\u043E\u043C\u043A\u043E\u0441\u0442\u044C",
  "settings.volume.note": "\u0421\u043A\u043E\u0440\u043E",
  "settings.soon": "\u0421\u043A\u043E\u0440\u043E",
  // — HUD (базовые подписи витальных) —
  "hud.money": "\u041D\u0430\u043B\u0438\u0447\u043D\u044B\u0435",
  "hud.bank": "\u0411\u0430\u043D\u043A",
  "hud.hunger": "\u0413\u043E\u043B\u043E\u0434",
  "hud.thirst": "\u0416\u0430\u0436\u0434\u0430",
  // — PHONE (база оболочки телефона) —
  "phone.home": "\u0413\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D",
  "phone.apps": "\u041F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  // — SHOP (магазин: покупка/продажа/крафт) —
  "shop.title": "\u041C\u0430\u0433\u0430\u0437\u0438\u043D",
  "shop.tab.buy": "\u041A\u0443\u043F\u0438\u0442\u044C",
  "shop.tab.sell": "\u041F\u0440\u043E\u0434\u0430\u0442\u044C",
  "shop.balance": "\u041D\u0430\u043B\u0438\u0447\u043D\u044B\u0435",
  "shop.buy": "\u041A\u0443\u043F\u0438\u0442\u044C",
  "shop.sell": "\u041F\u0440\u043E\u0434\u0430\u0442\u044C",
  "shop.qty": "\u041A\u043E\u043B-\u0432\u043E",
  "shop.each": "\u0437\u0430 \u0448\u0442.",
  "shop.have": "\u0412 \u043D\u0430\u043B\u0438\u0447\u0438\u0438: {n}",
  "shop.total": "\u0418\u0442\u043E\u0433\u043E",
  "shop.empty": "\u041F\u043E\u043B\u043A\u0438 \u043F\u0443\u0441\u0442\u044B",
  "shop.sell.empty": "\u041C\u0430\u0433\u0430\u0437\u0438\u043D \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u0432\u044B\u043A\u0443\u043F\u0430\u0435\u0442 \u0438\u0437 \u0432\u0430\u0448\u0435\u0433\u043E \u0438\u043D\u0432\u0435\u043D\u0442\u0430\u0440\u044F",
  "shop.craft.title": "\u0412\u0435\u0440\u0441\u0442\u0430\u043A",
  "shop.craft.make": "\u0421\u0434\u0435\u043B\u0430\u0442\u044C",
  "shop.craft.needs": "\u041D\u0443\u0436\u043D\u043E",
  "shop.craft.gives": "\u0414\u0430\u0451\u0442",
  "shop.craft.empty": "\u0417\u0434\u0435\u0441\u044C \u043D\u0435\u0447\u0435\u0433\u043E \u0438\u0437\u0433\u043E\u0442\u043E\u0432\u0438\u0442\u044C",
  // — пример интерполяции (для проверки параметров) —
  "common.greeting": "\u041F\u0440\u0438\u0432\u0435\u0442, {name}!"
};
const en = {
  // — COMMON —
  "common.open": "Open",
  "common.close": "Close",
  "common.back": "Back",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.confirm": "Confirm",
  "common.yes": "Yes",
  "common.no": "No",
  "common.language": "Language",
  "common.loading": "Loading\u2026",
  // — MENU —
  "menu.stats": "Stats",
  "menu.battlepass": "Battle Pass",
  "menu.character": "Character",
  "menu.business": "Business",
  "menu.organization": "Organization",
  "menu.achievements": "Achievements",
  "menu.settings": "Settings",
  // — MENU: shell / subtitles —
  "menu.kicker": "Player menu",
  "menu.close": "Close \xB7 F1",
  "menu.empty": "No data yet",
  // — STATS —
  "stats.kicker": "Profile",
  "stats.title": "Character overview",
  "stats.level": "Level",
  "stats.hours": "Hours played",
  "stats.cash": "Cash",
  "stats.bank": "Bank",
  "stats.reputation": "Reputation",
  "stats.deeds": "deeds",
  "stats.job": "Job",
  "stats.job.none": "Unemployed",
  "stats.rank": "Position",
  "stats.home": "Home",
  "stats.home.none": "No home",
  "stats.lastPlace": "Last location",
  "stats.hoursUnit": "h",
  // — BATTLE PASS —
  "bp.kicker": "Season",
  "bp.title": "Battle Pass",
  "bp.level": "Level {n}",
  "bp.daysLeft": "{n} days left",
  "bp.premium.active": "Premium active",
  "bp.premium.buy": "Unlock premium \xB7 {jc} JC",
  "bp.track": "Reward track",
  "bp.free": "Free",
  "bp.prem": "Premium",
  "bp.claim": "Claim",
  "bp.claimed": "Claimed",
  "bp.locked": "Locked",
  "bp.reach": "Lv. {n}",
  "bp.fair": "Rewards are cosmetic, status and convenience. No damage, no armor, no money.",
  "bp.openApp": "Open full pass",
  // — CHARACTER —
  "char.kicker": "Progression",
  "char.title": "Character sheet",
  "char.cl": "Character level",
  "char.skills": "Skills",
  "char.rep": "Reputation",
  "char.ranks": "Ranks",
  "char.rep.none": "No reputation in any circle yet",
  "char.ranks.none": "No job or faction",
  "char.openSheet": "Open sheet (P)",
  // — BUSINESS —
  "biz.kicker": "Empire",
  "biz.title": "My businesses",
  "biz.none": "You have no businesses yet",
  "biz.treasury": "Treasury",
  "biz.share": "Share",
  "biz.role.owner": "Owner",
  "biz.role.partner": "Partner",
  "biz.manager": "Manager",
  "biz.manager.none": "No manager",
  // — ORGANIZATION —
  "org.kicker": "Faction",
  "org.title": "Organization",
  "org.none": "You are not in a faction",
  "org.rank": "Rank",
  "org.members": "Members (online)",
  "org.turf": "Territory control",
  "org.turf.none": "No controlled nodes",
  "org.control": "control",
  // — ACHIEVEMENTS —
  "ach.kicker": "Progress",
  "ach.title": "Achievements",
  "ach.streak": "Login streak",
  "ach.days": "days",
  "ach.daysActive": "Active days",
  "ach.next": "Next milestone",
  "ach.milestones": "Milestones",
  "ach.claimed": "Claimed",
  "ach.locked": "Day {n}",
  "ach.none": "Milestones appear as you play",
  // — SETTINGS —
  "settings.title": "Settings",
  "settings.kicker": "Interface",
  "settings.language": "Language",
  "settings.language.ru": "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
  "settings.language.en": "English",
  "settings.applied": "Language changed",
  "settings.hud": "HUD display",
  "settings.hud.note": "Drag elements \u2014 F7 in game",
  "settings.volume": "Volume",
  "settings.volume.note": "Soon",
  "settings.soon": "Soon",
  // — HUD —
  "hud.money": "Cash",
  "hud.bank": "Bank",
  "hud.hunger": "Hunger",
  "hud.thirst": "Thirst",
  // — PHONE —
  "phone.home": "Home",
  "phone.apps": "Apps",
  // — SHOP —
  "shop.title": "Shop",
  "shop.tab.buy": "Buy",
  "shop.tab.sell": "Sell",
  "shop.balance": "Cash",
  "shop.buy": "Buy",
  "shop.sell": "Sell",
  "shop.qty": "Qty",
  "shop.each": "each",
  "shop.have": "In stock: {n}",
  "shop.total": "Total",
  "shop.empty": "Shelves are empty",
  "shop.sell.empty": "This shop buys nothing from your inventory",
  "shop.craft.title": "Workbench",
  "shop.craft.make": "Make",
  "shop.craft.needs": "Needs",
  "shop.craft.gives": "Gives",
  "shop.craft.empty": "Nothing to craft here",
  // — interpolation sample —
  "common.greeting": "Hi, {name}!"
};
const DICTS = { ru, en };
let lang = "ru";
const subs = /* @__PURE__ */ new Set();
function notify() {
  for (const fn of subs) {
    try {
      fn();
    } catch {
    }
  }
}
function getLang() {
  return lang;
}
function setLang(next) {
  const v = normalizeLang(next);
  if (!v || v === lang) return;
  lang = v;
  notify();
}
function applyLang(snap) {
  const v = normalizeLang(snap);
  if (!v || v === lang) return;
  lang = v;
  notify();
}
function subscribeLang(fn) {
  subs.add(fn);
  return () => {
    subs.delete(fn);
  };
}
function t(key, params) {
  let s = DICTS[lang]?.[key];
  if (s === void 0 && lang !== "ru") s = ru[key];
  if (s === void 0) s = key;
  if (params) {
    s = s.replace(/\{(\w+)\}/g, (m, p) => {
      const val = params[p];
      return val === void 0 || val === null ? m : String(val);
    });
  }
  return s;
}
let listenerInstalled = false;
function installLangListener() {
  if (typeof window === "undefined") return () => {
  };
  if (listenerInstalled) return () => {
  };
  listenerInstalled = true;
  const onMsg = (e) => {
    const d = e?.data;
    if (d && typeof d === "object" && d.type === "lang") applyLang(d.lang);
  };
  window.addEventListener("message", onMsg);
  return () => {
    window.removeEventListener("message", onMsg);
    listenerInstalled = false;
  };
}
export {
  applyLang,
  en,
  getLang,
  installLangListener,
  normalizeLang,
  ru,
  setLang,
  subscribeLang,
  t
};
